import { useDispatch, useSelector } from "react-redux";
import { Loader } from "@progress/kendo-react-indicators";
import RefreshIcon from "../../../assets/header/refresh.svg";
import "../shuttle_bus_booking.css";
import { useNavigate } from "react-router";
import { TableHeader } from "../../../components/reusableItems/header";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import {
  checkPermission,
  getUserPermission,
} from "../../../config/permission_helper";
import { Reusable_table } from "../../../components/reusableItems/table";
import {
  ConfigData,
} from "./configData";
import { useEffect, useState } from "react";
import { deleteSetStationById } from "../../../store/shuttle_bus_booking/set_station";
import { SHUTTLE_BUS_BOOKING_CONFIGURE_SUSPENSION_DETAILS, SHUTTLE_BUS_BOOKING_CONFIGURE_SUSPENSION_UPDATE, SHUTTLE_BUS_BOOKING_SET_STATION_DETAILS, SHUTTLE_BUS_BOOKING_SET_STATION_UPDATE } from "../../../routes";
import { ShowDialog } from "../../../components/reusableItems/dialog";
import { fetchConfigureSuspensionList, updateConfigureSuspensionStatus } from "../../../store/shuttle_bus_booking/configure_suspension";

export const ShuttleBusBookingConfigureSuspensionListing = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showStatus, setShowStatus] = useState(false);
  const [tempStatus, setTempStatus] = useState("");
  const [actionID, setActionID] = useState("");
  const [actionType, setActionType] = useState("");
  const [tempData, setTempData] = useState([]);

  const { loading, configure_suspension_list } = useSelector(
    (state) => state.shuttleBusConfigureSuspension
  );

  const userPermissions = getUserPermission();

  const viewPermssion = checkPermission(
    userPermissions,
    "bus_booking.access_suspension_config"
  );



  const getData = async (callback) => {
    dispatch(fetchConfigureSuspensionList()).then((res) => {
      const formattedData = res.payload.map(item => ({
        ...item,
        id: item.config_id,
        period: `${item.value} ${item.period_range == 'weeks' ? 'Weeks' : 'Months'}`,
        status: item.is_enabled ? 'Enable' : 'Disable'
      }));

      setTempData([...formattedData]);
    });
  };



  useEffect(() => {
    getData();
  }, []);

  const updateStatus = () => {
    setShowStatus(false);

    let params = { is_enabled: tempStatus == 'Enable', id: actionID }

    dispatch(updateConfigureSuspensionStatus({ data: params, id: actionID })).then((res) => {
      getData();

    });
  };


  const handleTableClick = (type, id) => {

    if (type === "View Details") {
      navigate(`${SHUTTLE_BUS_BOOKING_CONFIGURE_SUSPENSION_DETAILS}?id=${id}`);
    } else if (type === "Update Status") {
      setActionID(id);
      setActionType(type);
      setShowStatus(true);
      const result = tempData.find(item => item.config_id === id);
      setTempStatus(result.is_enabled ? "Enable" : "Disable");
    }

  };

  const RefreshData = () => {
    getData();
  };


  const icons = [
    {
      icon: RefreshIcon,
      title: "Refresh",
      action: RefreshData,
    },
    // {
    //   icon: ExportIcon,
    //   title: "Export",
    //   action: handleExport,
    // },
  ];


  return (
    <>
      {viewPermssion ? (
        <div className="container">



          <TableHeader title={"Configure Rules for Suspension"} icons={icons} />

          {showStatus && (
            <ShowDialog
              cancelbtn={() => setShowStatus(false)}
              title={"Update Status"}
              dropdownContent={"Set status"}
              dropdown={true}
              cancelContent={"Cancel"}
              confrimContent={"Update"}
              confrinbtn={updateStatus}
              dropdownData={["Enable", "Disable"]}
              dropdownOnChange={(e) => setTempStatus(e)}
              dropdownValue={tempStatus}
            />
          )}

          {(<div className="shuttle_bus_booking_child_box_main_detail_box">


            {loading ? (
              <Loader
                type="converging-spinner"
                style={{
                  width: "100%",
                  height: "calc(100vh - 165px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#ffffff4d",
                  position: "absolute",
                  zIndex: "999",
                }}
              />
            ) : (
              <Reusable_table
                key={tempData && tempData.map(i => i.status).join("-")}
                header={ConfigData}
                data={tempData}
                pagination={true}
                calculatePagi={true}
                pageChangeLoading={false}
                showRow={true}
                checkbox={false}
                //   handleTableClick={handleTableClick}
                handleAction={handleTableClick}
                maxHeight={""}
                maxWidth={"calc(100vw - 240px)"}
              />
            )}
          </div>
          )}
        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
